import React from "react"
import { Marker, Popup } from 'react-leaflet'
import L from 'leaflet'
import { useTranslation } from "../../hooks/useTranslation"

const UserMarker = React.memo(function UserMarker({ lat, lng, trackid, onClick, Latitude, Longitude }) {
    const { t } = useTranslation();

    // Modern user location icon with pulsing effect
    const userIconSvg = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
            <style>
                @keyframes pulse {
                    0% { transform: scale(1); opacity: 0.6; }
                    50% { transform: scale(1.5); opacity: 0.2; }
                    100% { transform: scale(2); opacity: 0; }
                }
                .pulse-ring {
                    transform-origin: center;
                    animation: pulse 2s ease-out infinite;
                }
            </style>
            <!-- Pulse ring -->
            <circle class="pulse-ring" cx="24" cy="24" r="12" fill="#62B5E5" opacity="0.4"/>
            <!-- Outer glow -->
            <circle cx="24" cy="24" r="14" fill="rgba(98, 181, 229, 0.2)"/>
            <!-- White border -->
            <circle cx="24" cy="24" r="10" fill="white" filter="drop-shadow(0 2px 4px rgba(0,0,0,0.2))"/>
            <!-- Inner blue circle -->
            <circle cx="24" cy="24" r="7" fill="#62B5E5"/>
            <!-- Highlight -->
            <circle cx="22" cy="22" r="2" fill="rgba(255,255,255,0.5)"/>
        </svg>
    `;

    const myIcon = L.divIcon({
        className: 'user-location-marker',
        html: userIconSvg,
        iconSize: [48, 48],
        iconAnchor: [24, 24],
        popupAnchor: [0, -24],
    });

    return (
        <Marker
            icon={myIcon}
            key={"usermarker" + trackid}
            eventHandlers={{
                click: () => { onClick(trackid, Latitude, Longitude); }
            }}
            position={[lat, lng]}
        >
            <Popup className="user-popup">
                <div className="popup-content">
                    <h6>{t('tracker.userMarker.title', 'Je bent hier!')}</h6>
                    <p>{t('tracker.userMarker.subtitle', 'Je was makkelijker te vinden dan Wally!')}</p>
                </div>
            </Popup>
        </Marker>
    )
});

// Memoize to prevent re-renders when position hasn't changed
UserMarker.displayName = 'UserMarker';

export default UserMarker
